/*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductImage', {
    name: 'Modify Component ProductImage',
    enabled: true,
    apply: () => ({
      props: (props, element) => {
        try {
          filtered = props.originalSize.filter(image => image.alt != "ad-img")
          props.images[0] = filtered[0].src
          if(filtered[1]) {
            props.images[1] = filtered[1].src
          }
        } catch (error) {
          console.warn(error)
        }
  
        return props;
      }
    }),
  });
}]);